<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm12 md12>
          <p style="font-size:18px">
            <b
              ><u>
                تقرير مرتجعات مورد {{ select_importer.name }} بتاريخ من
                {{ date_from }} الي تاريخ {{ date_to }}</u
              >
            </b>
          </p>
        </v-flex>

        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_importer"
            :items="importers"
            item-text="name"
            item-value="id"
            label=" أختر المورد "
            persistent-hint
            return-object
            single-line
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_from"
            v-model="modal_from"
            :return-value.sync="date_from"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_from"
                label="تاريخ من"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_from" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_from = false"
                >Cancel</v-btn
              >
              <v-btn
                flat
                color="primary"
                @click="$refs.dialog_from.save(date_from)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog_to"
            v-model="modal_to"
            :return-value.sync="date_to"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date_to"
                label="تاريخ الي"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date_to" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal_to = false"
                >Cancel</v-btn
              >
              <v-btn flat color="primary" @click="$refs.dialog_to.save(date_to)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>

        <v-flex xs12 sm6 md3>
          <v-btn @click="RebackImporterReport">تأكيد</v-btn>
        </v-flex>
        <br />
        <v-flex v-if="fatworas.length > 0" xs12 sm6 md4
          ><b>المجموع : </b> {{ total }}</v-flex
        >
        <v-flex v-if="fatworas.length > 0" xs12 sm6 md4
          ><b>عدد الفواتير المرتجعة : </b> {{ count_of_count }}</v-flex
        >
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td class="text-xs-right">{{ props.item.emp_name }}</td>
          <td class="text-xs-right">{{ props.item.final_price }}</td>
          <td class="justify-center layout px-0">
            <v-dialog
              v-model="detail_dialog"
              width="800"
              dark
              style="padding:10px"
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="ml-4"
                  v-on="on"
                  @click="detailItem(props.item)"
                >
                  book
                </v-icon>
              </template>

              <v-card>
                <v-card-title class="headline orange lighten-2" primary-title>
                  تفاصيل الفاتورة
                </v-card-title>

                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 md4>
                      الكود :
                      {{ item_detail.code }}
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      المسئول :
                      {{ item_detail.emp_name }}
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      اسم العميل :
                      {{ item_detail.importer_name }}
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      السعر قبل :
                      {{ item_detail.price }}
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      السعر بعد :
                      {{ item_detail.final_price }}
                    </v-flex>
                  </v-layout>
                  <hr />
                  <v-data-table
                    :headers="headers3"
                    :items="item_detail.fatwora_items"
                    class="elevation-1"
                    :rows-per-page-items="rowsPerPageItems"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.item_name }}</td>
                      <td>{{ props.item.item_num }}</td>
                      <td>{{ props.item.item_num_reback }}</td>
                      <td>{{ props.item.item_num_remain }}</td>
                      <td>{{ props.item.price }}</td>
                      <td>{{ props.item.total_reback_price }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" flat @click="detail_dialog = false">
                    موافق
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير</div>
    </v-container>
  </div>
</template>

<script>
import {
  items,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  importers,
  khazina,
  khazna_fatworas,
  RebackImporterReport
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [11400, 11800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,
    detail_dialog: false,
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: "كود الفاتورة",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "اسم المندوب",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "السعر",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "التفاصيل",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    headers3: [
      {
        text: "الصنف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "العدد المباع",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "العدد المرتجع",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: "العدد المتبقي",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "سعر الوحدة",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: "السعر الكلي",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    active: "",
    select_item: { id: "" },
    select_importer: { id: "" },
    search: "",
    comment: "",
    loading: true,

    khazina_fatworas: [],
    items: [],
    fatworas: [],
    importers: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    item_detail: {},
    total_rasid_efttahi: 0,
    all_of_total: 0,
    all_paid: 0,
    all_remain: 0,
    all_total_discount: 0,
    all_total_reback: 0,
    omola_total: 0,
    total: 0,
    count_of_count: 0,
    madionia_sabqa_of_madionia: "",
    madionia_sabqa: ""
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    omola_percentage() {
      return function(total, omola) {
        return (parseFloat(total) * parseFloat(omola)) / 100;
      };
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      importers().then(response => {
        this.importers = response.data;
        this.loading = false;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });

      items().then(response => {
        this.items = response.data;
      });
    },
    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_item = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_item.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_item.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_item.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina(this.select_importer.id).then(response => {
        this.theKhazna = response.data;
      });
    },
    detailItem(order) {
      this.item_detail = order;
    },
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    RebackImporterReport() {
      var frmData = new FormData();
      frmData.append("importer_id", this.select_importer.id);
      frmData.append("date_from", this.date_from);
      frmData.append("date_to", this.date_to);
      RebackImporterReport(frmData).then(response => {
        response.data.fatworas.length > 0
          ? (this.fatworas = response.data.fatworas)
          : (this.fatworas = []);
        this.total = response.data.total;
        this.count_of_count = response.data.count_of_count;
      });
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
